<template>
    <div class="tool-shape-warpper">
        <el-table v-for="(tableData, idx) in data" :key="idx" class="tool-table" :data="tableData.toolData.list" max-height="180">
            <el-table-column
                v-for="(item, index) in tableData.toolData.head"
                :key="index"
                :prop="tableData.toolData.head_column[index]"
                :label="item"
            >
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "ToolShape",
    props: ["data"],
    data() {
        return {
            rowStyle: { "background-color": "none" }
        };
    }
};
</script>

<style lang="scss">
.tool-shape-warpper {
    width: 100%;

    .tool-table {
        border-radius: 4px;
        margin-bottom: 4px !important;
    }
    .el-table td, .el-table th {
        padding: 5px 0;
    }
    .el-table .cell{
        line-height: 18px;
    }
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}


</style>
